import { getContrastRatio } from '@mui/material/styles'

export function getContrastText(background, colorOnDarkBackground, colorOnLightBackground) {

  const colorOnDark = colorOnDarkBackground || '#ffffff'
  const colorOnLight = colorOnLightBackground || '#000000'

  const contrastText = getContrastRatio(colorOnLight, background || '#FFFFFF') <= 5
    ? colorOnDark
    : colorOnLight

  return contrastText
}
